export const UPDATE_VERSION = 'UPDATE_VERSION';

export const updateVersion = () => {
  return {
    type: UPDATE_VERSION
  };
};
